var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.456 146.213C264.314 146.213 175.137 204.653 134.445 237.121V328.894H477.731C500.587 175.822 383.071 143.327 321.456 146.213Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.809 360.928C170.809 345.388 155.011 324.565 147.749 324.565L79.035 312.011C71.7737 312.011 59.9876 328.505 59.9876 344.045C59.9876 359.585 78.7 373.482 85.9613 373.482L156.649 380.841C163.911 380.841 170.809 376.468 170.809 360.928Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.809 360.928C170.809 345.388 155.011 324.565 147.749 324.565L73.4073 315.041C66.146 315.041 60.2596 327.639 60.2596 343.179C60.2596 358.719 66.481 366.988 82.931 372.616L156.649 380.841C163.911 380.841 170.809 376.468 170.809 360.928Z",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.062 362.441C165.702 358.396 157.722 350.844 152.679 352.991",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.555 374.562C161.062 370.869 155.036 364.11 150.877 366.617",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.434 365.65C171.739 350.125 200.221 328.007 213.739 327.402L359.102 320.898C372.621 320.293 384.143 332.388 384.838 347.913C385.532 363.438 375.136 376.513 361.617 377.118L199.685 384.364C186.166 384.969 173.129 381.175 172.434 365.65Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.434 365.65C171.739 350.125 200.221 328.007 213.739 327.402L359.102 320.898C372.621 320.293 384.143 332.388 384.838 347.913C385.532 363.438 375.136 376.513 361.617 377.118L199.685 384.364C186.166 384.969 173.129 381.175 172.434 365.65Z",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.697 367.062C178.737 362.832 188.425 354.839 194.857 356.7",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.157 378.862C185.124 375.032 192.393 367.942 197.73 370.212",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.743 161.704C122.757 148.428 88.554 119.902 67.0825 125.79C70.6899 139.931 77.039 172.196 73.5759 188.126C64.4851 196.929 46.4767 219.987 47.1693 241.805C49.3338 239.496 55.6541 235.831 63.6193 239.641C57.4145 248.443 45.4377 272.021 47.1693 295.917C50.7769 294.474 59.1174 292.454 63.6193 295.917C57.8472 300.967 48.0347 314.445 54.9612 327.951C58.4244 321.025 67.948 309.51 78.3375 318.86C90.0194 329.677 126.436 350.439 178.685 347.004C230.933 350.439 267.35 329.677 279.032 318.86C289.421 309.51 298.945 321.025 302.408 327.951C309.334 314.445 299.522 300.967 293.75 295.917C298.252 292.454 306.592 294.474 310.2 295.917C311.931 272.021 299.955 248.443 293.75 239.641C301.715 235.831 308.035 239.496 310.2 241.805C310.892 219.987 292.884 196.929 283.793 188.126C280.33 172.196 286.679 139.931 290.287 125.79C268.815 119.902 234.612 148.428 221.626 161.704C220.004 161.317 218.228 160.863 216.33 160.379C205.584 157.635 190.956 153.899 178.685 155.723C166.413 153.899 151.785 157.635 141.039 160.379C139.141 160.863 137.365 161.317 135.743 161.704Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.744 299.942C150.854 299.504 158.551 300.291 164.459 306.939C167.569 311.166 177.442 315.685 192.058 299.942C194.779 297.463 202.087 295.393 209.551 306.939C211.38 309.767 214.604 313.586 223.934 308.688",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.474 170.268C84.4945 176.785 50.0271 199.681 47.9896 239.124C51.1024 236.857 58.6864 233.684 64.1197 239.124C56.7621 253.009 43.2355 283.668 47.9896 295.229C51.1026 294.096 58.0078 292.509 60.7242 295.229C64.1197 298.63 48.8388 307.98 54.7815 324.132C58.1773 319.598 66.6668 311.891 73.4584 317.331",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.056 157.844C119.459 144.954 90.5903 122.069 68.7874 125.311C65.6094 125.783 64.0792 129.167 64.9976 132.246C69.9645 148.896 75.4653 176.96 71.3703 188.903",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.161 170.268C276.14 176.785 310.608 199.681 312.645 239.124C309.532 236.857 301.948 233.684 296.515 239.124C303.873 253.009 317.399 283.668 312.645 295.229C309.532 294.096 302.627 292.509 299.911 295.229C296.515 298.63 311.796 307.98 305.853 324.132C302.457 319.598 293.968 311.891 287.176 317.331",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.58 157.844C241.177 144.954 270.045 122.069 291.848 125.311C295.026 125.783 296.557 129.167 295.638 132.246C290.671 148.896 285.17 176.96 289.265 188.903",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.05 261.446C184.989 251.679 168.097 256.346 159.302 261.378C157.606 262.349 157.571 264.665 159.126 265.848C166.359 271.348 176.921 278.525 181.296 278.525C186.676 278.525 196.932 271.302 203.434 266.051C204.991 264.794 204.81 262.398 203.05 261.446Z",
    fill: "#1C1B1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.841 271.241L91.1045 261.795",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.886 290.899L92.4541 293.521",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242.486 271.241L276.223 261.795",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M244.441 290.899L274.873 293.521",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M180.332 273.05V305.95",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.865 158.333C157.678 152.705 187.345 144.827 227.518 158.333",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.934 339.716C190.289 344.044 112.731 350.014 72.5678 316.546",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.497 330.017C420.323 329.33 422.427 328.118 425.664 328.633C429.23 329.201 437.493 332.448 448.627 349.001C454.778 358.148 466.378 360.104 474.535 353.37C482.693 346.637 484.318 333.763 478.167 324.617C463.252 302.442 446.995 290.547 430.493 287.92C414.161 285.321 400.774 292.369 393.03 300.888C392.665 301.29 392.315 301.708 391.982 302.143C371.793 328.47 356.589 335.296 347.933 336.39C339.501 337.455 334.748 333.489 333.202 331.458C332.83 330.969 332.438 330.5 332.027 330.051C306.626 302.298 275.249 300.042 260.736 303.065C250.716 305.153 244.209 315.896 246.203 327.06C248.197 338.224 257.936 345.582 267.957 343.494C273.121 342.418 290.949 342.925 305.76 358.694C315.096 370.381 331.632 379.898 352.532 377.257C373.503 374.606 396.155 360.136 419.497 330.017Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 211.504C146.074 215.23 210.92 227.654 244.753 247.548",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.753 211.504C216.559 215.23 151.713 227.654 117.88 247.548",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M445.65 443.212L399.366 396.929",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 354.239,
    cy: 326.346,
    r: 81.5958,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.144 365.938C339.557 367.223 344.229 372.234 346.591 375.943C346.709 376.13 346.815 376.325 346.907 376.526C350.396 384.155 357.441 385.026 360.274 384.599C362.902 384.202 365.354 386.01 365.75 388.638C366.147 391.265 364.339 393.717 361.711 394.114C356.17 394.951 344.201 393.309 338.312 380.864C336.599 378.284 333.906 375.905 331.253 375.373C329.273 374.976 325.57 375.289 320.781 382.517C319.313 384.733 316.328 385.339 314.112 383.871C311.897 382.403 311.291 379.417 312.759 377.202C318.827 368.045 325.974 364.5 333.144 365.938Z",
    fill: "#1C1B1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.004 309.628C392.053 306.153 390.88 300.879 390.735 297.522C390.725 297.3 390.731 297.079 390.752 296.858C391.255 291.562 387.689 288.9 386.107 288.28C383.633 287.31 382.414 284.518 383.384 282.044C384.354 279.57 387.146 278.351 389.62 279.321C393.749 280.94 401.189 286.726 400.365 297.384C400.51 299.423 401.272 301.446 402.36 302.402C402.917 302.892 404.729 304.187 410.081 301.521C412.46 300.337 415.349 301.305 416.533 303.684C417.718 306.063 416.75 308.951 414.371 310.136C406.947 313.833 400.536 313.614 396.004 309.628Z",
    fill: "#1C1B1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.004 258.76C338.017 258.76 342.081 261.948 342.081 265.882L342.081 275.378C342.081 279.311 338.017 282.5 333.004 282.5C327.991 282.5 323.927 279.311 323.927 275.378L323.927 265.882C323.927 261.948 327.991 258.76 333.004 258.76Z",
    fill: "#1C1B1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.004 331.376C338.017 331.376 342.081 334.94 342.081 339.336L342.081 349.949C342.081 354.345 338.017 357.909 333.004 357.909C327.991 357.909 323.927 354.345 323.927 349.949L323.927 339.336C323.927 334.94 327.991 331.376 333.004 331.376Z",
    fill: "#1C1B1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.777 272.628C370.831 275.681 370.831 280.632 367.777 283.685L360.405 291.057C357.352 294.111 352.401 294.111 349.347 291.057C346.294 288.004 346.294 283.053 349.347 280L356.719 272.628C359.773 269.574 364.723 269.574 367.777 272.628Z",
    fill: "#1C1B1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.436 324.965C318.49 328.019 318.49 332.97 315.436 336.023L308.064 343.395C305.011 346.449 300.06 346.449 297.006 343.395C293.953 340.342 293.953 335.391 297.006 332.337L304.378 324.965C307.432 321.912 312.383 321.912 315.436 324.965Z",
    fill: "#1C1B1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.294 272.626C300.347 269.573 305.298 269.573 308.352 272.626L315.723 279.998C318.777 283.052 318.777 288.003 315.723 291.056C312.67 294.11 307.719 294.11 304.666 291.056L297.294 283.684C294.24 280.631 294.24 275.68 297.294 272.626Z",
    fill: "#1C1B1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.634 324.965C352.688 321.912 357.639 321.912 360.692 324.965L368.064 332.337C371.118 335.391 371.118 340.341 368.064 343.395C365.011 346.449 360.06 346.449 357.006 343.395L349.634 336.023C346.581 332.97 346.581 328.019 349.634 324.965Z",
    fill: "#1C1B1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.428 306.941C283.428 302.699 286.616 299.26 290.55 299.26L300.046 299.26C303.979 299.26 307.168 302.699 307.168 306.941C307.168 311.182 303.979 314.621 300.046 314.621L290.55 314.621C286.616 314.621 283.428 311.182 283.428 306.941Z",
    fill: "#1C1B1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.044 306.941C356.044 302.699 359.608 299.26 364.004 299.26L374.617 299.26C379.013 299.26 382.577 302.699 382.577 306.941C382.577 311.182 379.013 314.621 374.617 314.621L364.004 314.621C359.608 314.621 356.044 311.182 356.044 306.941Z",
    fill: "#1C1B1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M364.424 307.639C364.424 325.378 350.044 339.758 332.305 339.758C314.567 339.758 300.187 325.378 300.187 307.639C300.187 289.901 314.567 275.521 332.305 275.521C350.044 275.521 364.424 289.901 364.424 307.639Z",
    fill: "#1C1B1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M349.528 297.531C349.528 302.796 345.26 307.064 339.995 307.064C334.729 307.064 330.461 302.796 330.461 297.531C330.461 292.265 334.729 287.997 339.995 287.997C345.26 287.997 349.528 292.265 349.528 297.531Z",
    fill: "#F9F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M329.19 317.869C329.19 321.73 326.06 324.861 322.198 324.861C318.337 324.861 315.207 321.73 315.207 317.869C315.207 314.008 318.337 310.878 322.198 310.878C326.06 310.878 329.19 314.008 329.19 317.869Z",
    fill: "#F9F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M419.835 328.926C419.835 333.178 416.604 336.625 412.618 336.625C408.632 336.625 405.4 333.178 405.4 328.926C405.4 324.674 408.632 321.228 412.618 321.228C416.604 321.228 419.835 324.674 419.835 328.926Z",
    fill: "#1C1B1F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M376.531 261.083C376.531 264.006 374.161 266.376 371.238 266.376C368.315 266.376 365.945 264.006 365.945 261.083C365.945 258.16 368.315 255.79 371.238 255.79C374.161 255.79 376.531 258.16 376.531 261.083Z",
    fill: "#1C1B1F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.522 332.974C394.077 332.974 396.149 334.599 396.149 336.605L396.149 341.446C396.149 343.452 394.077 345.077 391.522 345.077C388.966 345.077 386.894 343.452 386.894 341.446L386.894 336.605C386.894 334.599 388.966 332.974 391.522 332.974Z",
    fill: "#1C1B1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.522 369.998C394.077 369.998 396.149 371.815 396.149 374.056L396.149 379.468C396.149 381.709 394.077 383.526 391.522 383.526C388.966 383.526 386.894 381.709 386.894 379.468L386.894 374.056C386.894 371.815 388.966 369.998 391.522 369.998Z",
    fill: "#1C1B1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.252 340.044C410.808 341.6 410.808 344.125 409.252 345.681L405.493 349.44C403.936 350.997 401.412 350.997 399.855 349.44C398.298 347.883 398.298 345.359 399.855 343.802L403.614 340.044C405.171 338.487 407.695 338.487 409.252 340.044Z",
    fill: "#1C1B1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.565 366.73C384.122 368.287 384.122 370.811 382.565 372.368L378.806 376.127C377.25 377.683 374.725 377.683 373.169 376.127C371.612 374.57 371.612 372.046 373.169 370.489L376.927 366.73C378.484 365.173 381.008 365.173 382.565 366.73Z",
    fill: "#1C1B1F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.316 340.043C374.873 338.487 377.397 338.487 378.954 340.043L382.712 343.802C384.269 345.359 384.269 347.883 382.712 349.44C381.156 350.997 378.631 350.997 377.075 349.44L373.316 345.681C371.759 344.124 371.759 341.6 373.316 340.043Z",
    fill: "#1C1B1F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.001 366.729C401.557 365.172 404.082 365.172 405.638 366.729L409.397 370.488C410.954 372.044 410.954 374.569 409.397 376.125C407.84 377.682 405.316 377.682 403.759 376.125L400.001 372.367C398.444 370.81 398.444 368.286 400.001 366.729Z",
    fill: "#1C1B1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.246 357.539C366.246 355.376 367.872 353.623 369.877 353.623L374.719 353.623C376.724 353.623 378.35 355.376 378.35 357.539C378.35 359.702 376.724 361.455 374.719 361.455L369.877 361.455C367.872 361.455 366.246 359.702 366.246 357.539Z",
    fill: "#1C1B1F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.27 357.539C403.27 355.376 405.087 353.623 407.328 353.623L412.739 353.623C414.98 353.623 416.797 355.376 416.797 357.539C416.797 359.702 414.98 361.455 412.739 361.455H407.328C405.087 361.455 403.27 359.702 403.27 357.539Z",
    fill: "#1C1B1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M407.542 357.894C407.542 366.938 400.21 374.27 391.166 374.27C382.122 374.27 374.79 366.938 374.79 357.894C374.79 348.85 382.122 341.519 391.166 341.519C400.21 341.519 407.542 348.85 407.542 357.894Z",
    fill: "#1C1B1F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M400.664 353.11C400.664 355.915 398.39 358.189 395.585 358.189C392.78 358.189 390.506 355.915 390.506 353.11C390.506 350.305 392.78 348.031 395.585 348.031C398.39 348.031 400.664 350.305 400.664 353.11Z",
    fill: "#F9F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M389.829 363.945C389.829 366.002 388.162 367.67 386.105 367.67C384.047 367.67 382.38 366.002 382.38 363.945C382.38 361.888 384.047 360.221 386.105 360.221C388.162 360.221 389.829 361.888 389.829 363.945Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFip);
export default __webpack_public_path__ + "static/media/고질병_FIP.18893c0f8974a996b8d55d5bdde36b5b.svg";
export { ForwardRef as ReactComponent };